import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(() => ({
  root: {
    overflowX: 'auto',
  },
}))(Box);
